"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
function useDraggable(props) {
    const { position: { x, y }, parentElement, fromEdge = false, dragHandleClassName, } = props;
    const isActive = (0, react_1.useRef)(false);
    const positionRef = (0, react_1.useRef)({ x, y });
    const [position, setPosition] = (0, react_1.useState)({
        value: { x, y },
        action: null,
    });
    const onPointerDown = (0, react_1.useCallback)((e) => {
        e.stopPropagation();
        isActive.current = true;
        const eventTarget = e.currentTarget;
        const classes = e.target.getAttribute('class')?.split(' ') || [];
        if ((dragHandleClassName && classes.includes(dragHandleClassName)) ||
            !dragHandleClassName) {
            const _parentElement = parentElement || eventTarget?.parentElement;
            if (_parentElement) {
                const parentBounding = _parentElement.getBoundingClientRect();
                const currentBounding = eventTarget?.getBoundingClientRect();
                const startPosition = {
                    x: parentBounding.x +
                        (!fromEdge ? e.clientX - currentBounding.x : 0),
                    y: parentBounding.y +
                        (!fromEdge ? e.clientY - currentBounding.y : 0),
                };
                if (parentBounding) {
                    positionRef.current = startPosition;
                }
                setPosition((prevPortion) => ({ ...prevPortion, action: 'start' }));
            }
            window.addEventListener('pointermove', moveCallback);
            window.addEventListener('pointerup', upCallback);
        }
        function upCallback(e) {
            e.stopPropagation();
            if (isActive.current) {
                setPosition({
                    value: {
                        x: e.clientX - positionRef.current.x,
                        y: e.clientY - positionRef.current.y,
                    },
                    action: 'end',
                });
                isActive.current = false;
            }
            window.removeEventListener('pointermove', moveCallback);
            window.removeEventListener('pointerup', upCallback);
        }
        function moveCallback(e) {
            e.stopPropagation();
            if (isActive.current) {
                setPosition({
                    value: {
                        x: e.clientX - positionRef.current.x,
                        y: e.clientY - positionRef.current.y,
                    },
                    action: 'move',
                });
            }
        }
    }, [dragHandleClassName, fromEdge, parentElement]);
    return (0, react_1.useMemo)(() => ({
        onPointerDown,
        position,
        isActive: isActive.current,
    }), [onPointerDown, position]);
}
exports.default = useDraggable;
